import {
  GET_POLICY_DETAILS_TRACK
} from "./types";


export function getPolicyDetails(data) {
  return {
    type: GET_POLICY_DETAILS_TRACK,
    payload: data,
  };
}

